import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// -------------------- Modal Error Handler Dialog --------------------
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.ModalErrorHandler.';
  public static readonly close = `${Id.prefix}close`;
  public static readonly copiedToClipboard = `${Id.prefix}copiedToClipboard`;
  public static readonly copyToClipboard = `${Id.prefix}copyToClipboard`;
  public static readonly pleaseSubmitTicket = `${Id.prefix}pleaseSubmitTicket`;
  public static readonly noteCorruption = `${Id.prefix}noteCorruption`;
}

export class LangModalErrorHandler {
  private constructor() {}
  public static close(): string {
    return interpolate(Id.close);
  }
  public static copiedToClipboard(): string {
    return interpolate(Id.copiedToClipboard);
  }
  public static copyToClipboard(): string {
    return interpolate(Id.copyToClipboard);
  }
  public static pleaseSubmitTicket(): string {
    return interpolate(Id.pleaseSubmitTicket);
  }
  public static noteCorruption(): string {
    return interpolate(Id.noteCorruption);
  }
}

export class ModalErrorHandlerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.close, 'Close', 'Button: close');
    register.add(Id.copiedToClipboard, 'Copied to Clipboard', 'Button: copied to clipboard');
    register.add(Id.copyToClipboard, 'Copy to Clipboard', 'Button: copy to clipboard');
    register.add(
      Id.pleaseSubmitTicket,
      'Please submit an IT Ticket to your support with the following details',
      'Error dialog: submit ticket'
    );
    register.add(
      Id.noteCorruption,
      'Note that continuing what you are doing may result in corruption or loss of data',
      'Error dialog: note about corruption'
    );
  }
}
